import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type ReportForApiCreate, type ReportForApiUpdate} from './types';

const domain = 'ENTITIES/ACCIDENT_INCIDENT_REPORTS';

export const {
    action: fetchAllForChild,
    success: fetchAllForChildSuccess,
    failed: fetchAllForChildFailed,
} = createAction(`${domain}/FETCH_ALL_FOR_CHILD`, (childId: string) => ({childId}));

export const {
    action: fetchWithIds,
    success: fetchWithIdsSuccess,
    failed: fetchWithIdsFailed,
} = createAction(`${domain}/FETCH_WITH_IDS`, (reportIds: string[]) => ({reportIds}));

export const {
    action: create,
    success: createSuccess,
    failed: createFailed,
    aborted: createAbort,
} = createAction(`${domain}/CREATE`, (report: ReportForApiCreate) => ({report}));

export const {
    action: update,
    success: updateSuccess,
    failed: updateFailed,
    aborted: updateAbort,
} = createAction(`${domain}/UPDATE`, (report: ReportForApiUpdate, completeTestChildAction?: () => void) => ({
    report,
    completeTestChildAction,
}));

export const {
    action: deleteReport,
    success: deleteReportSuccess,
    failed: deleteReportFailed,
    aborted: deleteReportAborted,
} = createAction(`${domain}/DELETE_REPORT`, (reportId: string, childId: string) => ({reportId, childId}));

export const {
    action: acknowledge,
    success: acknowledgeSuccess,
    failed: acknowledgeFailed,
} = createAction(
    `${domain}/ACKNOWLEDGE`,
    (reportId: string) => ({reportId}),
    data => data,
    (error, reportId) => ({error, reportId}),
);
